/**
 * Metadata state updates (legacy action types). Used by metadataSlice extraReducers.
 */
import {
  PAGE_NAME,
  PAGE_SIZE_DEFAULT,
  SEARCH_BY_DEFAULT,
  SEARCH_VALUE_DEFAULT,
  SEARCH_TYPE_DEFAULT,
  SEARCH_TYPE_BASIC,
  SEARCH_TYPE_ADVANCE,
  CLICK_COPY_LINK,
  CLICK_SHARE_LINK,
  CLICK_SHARE_DOCUMENT,
  IS_TOOL_BAR_DISABLED,
  RELEASE_LEVEL_DEFAULT,
  RELEASE_LEVEL_START_DATE,
  RELEASE_LEVEL_END_DATE,
  RELEASE_LEVEL_ANY_DATE,
  RELEASE_LEVEL_ONLY_WHERE_USER_INVOLVED,
  MORE_DETAILS_IS_MODAL_DEFAULT,
  MORE_TEMPLATE_DETAILS_IS_MODAL_DEFAULT,
  ACTIVE_PAGE,
  COPY_LINK_TOGGLE_VALUE_DEFAULT,
  COPY_LINK_TOGGLE_VALUE_DOWNLOAD,
  UPLOADED_LINKS,
  LINK_PLATFORM,
  RELEASE_LEVEL_DOC_CLASS,
  RELEASE_LEVEL_FORMAT,
  ONEDRIVE_OPTIONS_DATE,
  ONEDRIVE_PASSWORD,
  DEFAULT_CONTACTS,
  DEFAULT_DIALOG_VISIBLE,
  DEFAULT_SUCESS_DIALOG_VISIBLE,
  DEFAULT_MESSAGE_BOX_VISIBLE,
  DEFAULT_DIALOG_TYPE,
  DEFAULT_ONE_DRIVE_LINK_SETTING_OPTION,
  DOCCLASS_VALUES,
  LOGICALUNIT_VALUES,
  DOCCLASS_FORMAT_VALUES,
  HIDE_SIDE_BAR,
  SMALL_SCREEN_SIZE,
  CHECKIN_NEW,
  LOADER_ACTIVE,
  URL_GENERATE,
  ON_SEARCH_DISABLE,
  ON_EMPTY_RESULTS,
  ON_REVISION_SEARCH_LOAD,
  ON_ADV_OBJ_MODEL_HIDE,
  ON_ADV_OBJ_RECORD_SELECTED,
  ADV_RESULTS_STATUS,
  DATA_LOAD_STATUS,
  USER_DATA_LOAD_STATUS,
  CHECKIN_NEW_PAGE_NAME,
  ON_CHECKIN_NEW_PAGE_NAME,
  ON_NO_OF_RECORDS_CHANGED_DEFAULT,
  DEFAULT_MAIN_COMP_WIDTH,
  ACCESS_TOKEN_STATUS,
  DOCUMENT_MODE,
  USER_TOKEN_STATUS,
  DOCUMENT_LOAD_STATUS,
  MODEL_STATUS,
  REFRESH_TOKEN_ACTION,
  RESPONSE_TYPE,
  PROGRESS_STATUS,
  DOC_CHECK_IN_TYPE
} from "../../constants/metaData";
import {
  ON_SELECTED_PAGE_CHANGED,
  ON_APP_CONFIGURE,
  ON_USER_DATA_LOAD,
  ON_AZURE_USER_LOAD,
  ON_IFS_USER_LOAD,
  ON_PAGE_SIZE_CHANGE,
  ON_SEARCH_BY_CHANGE,
  ON_COPY_LINK_CLICK,
  ON_SHARE_LINK_CLICK,
  ON_CHECK_IN_SUCCESS,
  ON_SHARE_DOCUMENT_CLICK,
  ON_ROW_SELECTION_CHANGE,
  ON_ONE_WORD_SELECTED,
  ON_ONE_PDF_SELECTED,
  SET_INITIAL_ROW_SELECTION_DETAILS,
  ON_SEARCH_TYPE_CHANGE,
  ON_RELEASE_LEVEL_CHANGE,
  ON_ADVANCE_SEARCH_START_DATE_CHANGE,
  ON_ADVANCE_SEARCH_END_DATE_CHANGE,
  ON_ANY_DATE_CHECKED,
  ON_ONLY_WHERE_USER_CHECKED,
  ON_SEARCH_VALUE_CHANGE,
  ON_CONTEXTUAL_MENU_DETAILS_CLICK,
  ON_CONTEXTUAL_MENU_TEMPLATE_DETAILS_CLICK,
  ON_CLOSE_MORE_DETAILS_MODAL_CLICK,
  ON_CLOSE_TEMPLATE_MORE_DETAILS_MODAL_CLICK,
  ON_CONTEXTUAL_MENU_COPY_LINK_CLICK,
  ON_CONTEXTUAL_MENU_SHARE_LINK_CLICK,
  ON_CONTEXTUAL_MENU_SHARE_DOCUMENT_CLICK,
  ON_UPLOAD_CLICK,
  ON_PLATFORM_OPEN_LINK_CHANGE,
  ON_ACTIVE_PAGE_CHANGE,
  ON_COPYLINK_TOGGLE_CHANGE,
  ON_DOWNLOAD_VIEWTOGGLE_CHANGE,
  ON_ONEDRIVE_SETTINGS_CHANGE,
  ON_ONE_DRIVE_TOGGLE_ENABLE_DOWNLOAD_OR_NOT,
  ON_ONE_DRIVE_ALLOW_EDITING_CHECKED,
  ON_ONE_DRIVE_SETTING_APPLY_CLICK,
  ON_ONE_DRIVE_SETTING_CANCEL_CLICK,
  POPUP_LINK_SETTING_MODAL,
  POPUP_DOWNLOAD_VIEW_MODAL,
  ON_POPUP_DOWNLOAD_VIEW_APPLY,
  ON_ONEDRIVE_TOGGLE_OPEN_IN_REVIEW_MODE_ONLY,
  ON_ADVANCE_SEARCH_DOC_CLASS_CHANGE,
  ON_ADVANCE_SEARCH_FORMAT_CHANGE,
  ON_ONEDRIVE_OPTIONS_DATE_CHANGE,
  ON_ONEDRIVE_OPTIONS__PASSWORD_CHANGE,
  ON_ONEDRIVE_OPTIONS__PEOPLE_SELECTED,
  PEOPLE_PICKER_CONTACTS,
  ON_DIALOG_MENU_OK_BUTTON_CLICK,
  ON_SUCCESS_DIALOG_MENU_OK_BUTTON_CLICK,
  ON_MESSAGE_BOX_OK_BUTTON_CLICK,
  ON_WRONG_FILE_FORMAT,
  ON_MESSAGE_BOX_OPEN,
  ON_DISPLAY_DETAILS_BUTTON,
  ON_MESSAGE_BOX_INVOKE,
  ON_WRONG_FILE_FORMAT_TYPE,
  DOCCLASS_FORMAT_VALUES_FILTERED,
  ON_ONE_DRIVE_APPLY_BUTTON_DISABLE,
  ON_REDIRECT_LINKS,
  ON_DOC_CHECKIN_TYPE,
  ON_RECENT_OBJECT_VALUES,
  ON_CHECKOUT_STATUS,
  ON_REVISIONSEARCH_CLICK,
  ON_REVISIONSEARCH_ITEM_SELECT,
  ON_ADV_OBJ_SELECT_COMPLETED,
  ON_VIEWCOPY_UPLOAD_FAILED,
  ON_NEWREVISION_DISABLED,
  ON_ADV_OBJ_RESULTS_STATUS_CHANGED,
  ON_ADV_OBJ_META_DATA_STATUS_CHANGED,
  ON_DOCUMENT_UPLOAD_FAILED,
  FETCH_COPYRIGHT,
  TOGGLE_SIDEBAR,
  CLICKED_ON_SAME_NAV_ITEM,
  ON_MAIN_COMP_WIDTH_CHANGE,
  ON_RESET_LANGUAGE,
  ON_ONEDRIVE_DATALOAD,
  ON_OBJECTCONNECTION_DATALOAD,
  ON_CHECK_IN_TO_IFS_CLICKED,
  ON_CLEAR_ONEDRIVE_DOCUMENT_DOWNLOAD_URL,
  ON_CHECKED_OUT_TO_ME,
  ON_IFS_DOCUMENT_LOAD_CHANGED,
  ON_IFS_DOCUMENT_BACKGROUND_LOAD_CHANGED,
  ON_ONEDRIVE_DOCUMENT_BACKGROUND_LOAD_CHANGED,
  ON_DOCUMENT_REVISION_LOAD_CHANGED,
  ON_NO_OF_RECORDS_CHANGED,
  ON_PAGINATION_LOAD,
  ON_FILTER_VISIBILITY,
  ON_ONEDRIVE_FILTER_VISIBILITY,
  ON_NEWREVISION_INFO_CHANGED,
  ON_NEWREVISION_DOC_INFO_CHANGED,
  ON_TOKEN_FAIL,
  ON_ACCESS_TOKEN_STATUS,
  ON_DOCUMENT_STORAGE_MODE,
  ON_ACCORDION_EXPANDED_CHANGE,
  ON_ERROR_MESSAGE_INVOKE,
  ON_SERVER_ERROR_MESSAGE_INVOKE,
  ON_EXCEPTION_MESSAGE_INVOKE,
  ON_WARNING_MESSAGE_INVOKE,
  ON_SUCCESS_MESSAGE_INVOKE,
  ON_IFS_DOCUMENT_DETAILS_LOAD_STATUS,
  ON_IFS_DOCUMENT_DETAILS_MODEL_OPEN,
  ON_LOGIN_REFRESH_PREACTION_INVOKE,
  ON_SUCCESS_MESSAGE_CLOSE
} from "../../constants/actionTypes";
import {
  EMPTY_RESULTS,
  ERROR_TYPE,
  VALIDATION_FAILED_ERROR,
  AZURE_USER_ACCESS_DENIED,
  AZURE_USER_AUTHENTICATION_FAILURE,
  IFS_SERVER_ERROR,
  ERROR_DETAILS,
  EXCEPTION_ERROR,
  WARNING_TYPE,
  SUCCESS_TYPE,
  FORBIDDEN,
  SERVER_RESPONSE_ISSUE,
  NO_USER_ACCOUNT,
  BAD_REQUEST_ERROR,
  DEFAULT_SUCCESS_MESSAGE,
  DEFAULT_SUCCESS_TITLE
} from "../../constants/messageTypes";
import { getPayloadValue, isValidPlayload } from "../../../functions/reduxMethod";
const defaultStartDate = (() => {
  const d = new Date();
  d.setDate(d.getDate() - 90);
  return d.toISOString();
})();

export const metadataInitialState = {
  ifsDocumentDetailsModelOpen: MODEL_STATUS.close,
  selectedPageName: PAGE_NAME.home,
  appConfigured: DATA_LOAD_STATUS.onStart,
  userDataLoadStatus: USER_DATA_LOAD_STATUS.onStart,
  azureUserStatus: USER_TOKEN_STATUS.invalid,
  ifsUserStatus: USER_TOKEN_STATUS.invalid,
  pageSize: PAGE_SIZE_DEFAULT,
  searchType: SEARCH_TYPE_DEFAULT,
  searchBy: SEARCH_BY_DEFAULT,
  searchValue: SEARCH_VALUE_DEFAULT,
  noOfRecords: ON_NO_OF_RECORDS_CHANGED_DEFAULT,
  copyLinkClick: CLICK_COPY_LINK,
  shareLinkClick: CLICK_SHARE_LINK,
  shareDocumentClick: CLICK_SHARE_DOCUMENT,
  isToolBarDisabled: IS_TOOL_BAR_DISABLED,
  isOneWordSelected: IS_TOOL_BAR_DISABLED,
  isOnePdfSelected: IS_TOOL_BAR_DISABLED,
  rowSelectionDetails: [],
  contextualMenuSelectedRowDetails: [],
  contextualMenuSelectedTemplateDetails: [],
  moreDetailsIsModal: MORE_DETAILS_IS_MODAL_DEFAULT,
  moreTemplateDetailsIsModal: MORE_TEMPLATE_DETAILS_IS_MODAL_DEFAULT,
  advanceSearchReleaseLevel: RELEASE_LEVEL_DEFAULT,
  advanceSearchStartDate: defaultStartDate,
  advanceSearchEndDate: RELEASE_LEVEL_END_DATE,
  advanceSearchAnyDate: RELEASE_LEVEL_ANY_DATE,
  advanceSearchOnlyUserInvolved: "FALSE",
  checkedOutToMe: RELEASE_LEVEL_ONLY_WHERE_USER_INVOLVED,
  uploadedLinks: UPLOADED_LINKS,
  linkPlatform: LINK_PLATFORM,
  copyLinkToggleValue: COPY_LINK_TOGGLE_VALUE_DEFAULT,
  copyLinkToggleValueDownload: COPY_LINK_TOGGLE_VALUE_DOWNLOAD,
  activePage: ACTIVE_PAGE,
  oneDriveLinkSettingOption: DEFAULT_ONE_DRIVE_LINK_SETTING_OPTION,
  linkDownloadViewOption: false,
  oneDriveAllowEditing: false,
  oneDriveAllowDownload: false,
  oneDriveReviewModeOnly: false,
  applyOneDriveSettings: false,
  linkSettingsModalState: false,
  downloadViewModalState: false,
  advanceSearchDocClass: RELEASE_LEVEL_DOC_CLASS,
  advanceSearchFormat: RELEASE_LEVEL_FORMAT,
  onedriveOptionsDate: ONEDRIVE_OPTIONS_DATE,
  onedrivePassword: ONEDRIVE_PASSWORD,
  selectedPeople: [],
  contacts: DEFAULT_CONTACTS,
  openDialogMenu: DEFAULT_DIALOG_VISIBLE,
  openSucessDialog: DEFAULT_SUCESS_DIALOG_VISIBLE,
  openDialogMenuType: DEFAULT_DIALOG_TYPE,
  openMessageBox: DEFAULT_MESSAGE_BOX_VISIBLE,
  displayDetailsButton: true,
  messageBoxInfo: [],
  docClassVal: [],
  LogicalUnit_Val: [],
  docClassFormatVal: [],
  docClassFormatValFiltered: [],
  hideSideBar: false,
  isSmallScreen: false,
  isOneDriveApplyButtonDisable: false,
  docCheckinType: DOC_CHECK_IN_TYPE.checkinNew,
  loaderActive: LOADER_ACTIVE,
  urlGenerate: URL_GENERATE,
  isSearchDisable: false,
  recentObjects: [],
  emptyResultText: EMPTY_RESULTS,
  checkoutStatusValue: "",
  searchRevisionHide: true,
  selectedRevisionItem: [],
  isSearchRevisionOn: true,
  searchAdvanceObjectHide: true,
  searchAdvanceObjectSelected: false,
  advObjCompleted: false,
  viewCopyFail: false,
  newRevisionDisable: true,
  advSearchMedatDataStatus: DATA_LOAD_STATUS.onStart,
  advObjResultsStatus: PROGRESS_STATUS.onStart,
  documentUploadFailed: false,
  copyRight: "",
  isToggleSideBar: false,
  checkinPageName: CHECKIN_NEW_PAGE_NAME.file,
  PageLoadLanguage: "",
  isClickedOnSameNavItem: false,
  isMainCompWidthChange: DEFAULT_MAIN_COMP_WIDTH,
  oneDriveDataLoad: DATA_LOAD_STATUS.onStart,
  logicalUnit: [],
  objectConnectionDataLoad: DATA_LOAD_STATUS.onStart,
  isCheckInToIFSClicked: false,
  isOneDriveDownloadUrlCleared: false,
  loadIFSDocument: DATA_LOAD_STATUS.onStart,
  loadIFSDocumentBackgroud: DATA_LOAD_STATUS.onStart,
  loadOneDriveDocumentBackgroud: DATA_LOAD_STATUS.onStart,
  loadDocumentRevisions: DATA_LOAD_STATUS.onStart,
  paginationLoad: DATA_LOAD_STATUS.onStart,
  isFilterVisible: false,
  isOneDriveFilterVisible: false,
  newRevisionInfoChange: DATA_LOAD_STATUS.onStart,
  newRevisionDocInfo: [],
  accessTokenStatus: ACCESS_TOKEN_STATUS.invalid,
  documentStorageMode: DOCUMENT_MODE.ifs,
  existingRevInfoChange: DATA_LOAD_STATUS.onStart,
  existingRevisionInfo: [],
  accordionExpandedPanel: "workingDocumentPanel",
  ifsDocumentDetailsStatus: DOCUMENT_LOAD_STATUS.onStart,
  tokenRefreshPreActionInvoke: {
    retry: 0,
    actionType: REFRESH_TOKEN_ACTION.none,
    refreshResponse: RESPONSE_TYPE.none,
  },
  successMessageInfo: [],
  showSuccessMessage: false,
};

function metadataReducer(state = metadataInitialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ON_IFS_DOCUMENT_DETAILS_MODEL_OPEN:
      return {
        ...state,
        ifsDocumentDetailsModelOpen: getPayloadValue(
          payload,
          MODEL_STATUS.close,
        ),
      };
    case ON_SELECTED_PAGE_CHANGED:
      return {
        ...state,
        selectedPageName: payload,
      };
    case ON_APP_CONFIGURE:
      return {
        ...state,
        appConfigured: payload,
      };
    case ON_USER_DATA_LOAD:
      return {
        ...state,
        userDataLoadStatus: payload,
      };
    case ON_AZURE_USER_LOAD:
      return {
        ...state,
        azureUserStatus: payload,
      };
    case ON_IFS_USER_LOAD:
      return {
        ...state,
        ifsUserStatus: payload,
      };
    case ON_IFS_DOCUMENT_LOAD_CHANGED:
      return {
        ...state,
        loadIFSDocument: payload,
      };
    case ON_IFS_DOCUMENT_BACKGROUND_LOAD_CHANGED:
      return {
        ...state,
        loadIFSDocumentBackgroud: payload,
      };
    case ON_ONEDRIVE_DOCUMENT_BACKGROUND_LOAD_CHANGED:
      return {
        ...state,
        loadOneDriveDocumentBackgroud: payload,
      };
    case ON_DOCUMENT_REVISION_LOAD_CHANGED:
      return {
        ...state,
        loadDocumentRevisions: payload,
      };
      break;
    case ON_PAGE_SIZE_CHANGE:
      return {
        ...state,
        pageSize: payload,
      };
      break;
    case ON_SEARCH_BY_CHANGE:
      return {
        ...state,
        searchBy: payload,
      };
      break;
    case ON_NO_OF_RECORDS_CHANGED:
      return {
        ...state,
        noOfRecords: payload,
      };
    case ON_COPY_LINK_CLICK:
      if (payload === false) {
        return {
          ...state,
          copyLinkClick: payload,
          uploadedLinks: [],
          copyLinkToggleValue: COPY_LINK_TOGGLE_VALUE_DEFAULT,
          copyLinkToggleValueDownload: COPY_LINK_TOGGLE_VALUE_DOWNLOAD,
          linkPlatform: LINK_PLATFORM,
        };
      } else {
        return {
          ...state,
          copyLinkClick: payload,
          uploadedLinks: [],
        };
      }
      break;
    case ON_SHARE_LINK_CLICK:
      return {
        ...state,
        shareLinkClick: payload,
      };
      break;
    case ON_CHECK_IN_SUCCESS:
      return {
        ...state,
        openSucessDialog: payload,
      };
      break;
    case ON_SHARE_DOCUMENT_CLICK:
      return {
        ...state,
        shareDocumentClick: payload,
      };
      break;
    case SET_INITIAL_ROW_SELECTION_DETAILS:
      return {
        ...state,
        rowSelectionDetails: payload,
      };
      break;
    case ON_ROW_SELECTION_CHANGE:
      if (payload.length === 0) {
        return {
          ...state,
          rowSelectionDetails: payload,
          isToolBarDisabled: true,
        };
      } else {
        return {
          ...state,
          rowSelectionDetails: payload,
          isToolBarDisabled: false,
        };
      }
      break;
    case ON_ONE_WORD_SELECTED:
      return {
        ...state,
        isOneWordSelected: payload,
      };
    case ON_ONE_PDF_SELECTED:
      return {
        ...state,
        isOnePdfSelected: payload,
      };
    case ON_SEARCH_TYPE_CHANGE:
      if (payload === true) {
        return {
          ...state,
          searchType: SEARCH_TYPE_ADVANCE,
        };
      } else {
        return {
          ...state,
          searchType: SEARCH_TYPE_BASIC,
          advanceSearchReleaseLevel: RELEASE_LEVEL_DEFAULT,
          advanceSearchStartDate: RELEASE_LEVEL_START_DATE,
          advanceSearchEndDate: RELEASE_LEVEL_END_DATE,
          advanceSearchAnyDate: RELEASE_LEVEL_ANY_DATE,
          advanceSearchOnlyUserInvolved: RELEASE_LEVEL_ONLY_WHERE_USER_INVOLVED,
          advanceSearchDocClass: RELEASE_LEVEL_DOC_CLASS,
          advanceSearchFormat: RELEASE_LEVEL_FORMAT,
        };
      }
      break;
    case ON_RELEASE_LEVEL_CHANGE:
      return {
        ...state,
        advanceSearchReleaseLevel: payload,
      };
      break;
    case ON_ADVANCE_SEARCH_START_DATE_CHANGE:
      return {
        ...state,
        advanceSearchStartDate: payload instanceof Date ? payload.toISOString() : (payload ?? state.advanceSearchStartDate),
      };
      break;
    case ON_ADVANCE_SEARCH_END_DATE_CHANGE:
      return {
        ...state,
        advanceSearchEndDate: payload instanceof Date ? payload.toISOString() : (payload ?? state.advanceSearchEndDate),
      };
      break;
    case ON_ANY_DATE_CHECKED:
      return {
        ...state,
        advanceSearchAnyDate: payload,
      };
      break;
    case ON_ONLY_WHERE_USER_CHECKED:
      return {
        ...state,
        advanceSearchOnlyUserInvolved: payload,
      };
    case ON_CHECKED_OUT_TO_ME:
      return {
        ...state,
        checkedOutToMe: payload,
      };
      break;
    case ON_SEARCH_VALUE_CHANGE:
      return {
        ...state,
        searchValue: payload,
      };
      break;
    case ON_CONTEXTUAL_MENU_DETAILS_CLICK:
      return {
        ...state,
        contextualMenuSelectedRowDetails: payload,
        moreDetailsIsModal: true,
      };
      break;
    case ON_IFS_DOCUMENT_DETAILS_LOAD_STATUS:
      return {
        ...state,
        ifsDocumentDetailsStatus: getPayloadValue(
          payload,
          DOCUMENT_LOAD_STATUS.onStart,
        ),
      };
      break;
    case ON_CONTEXTUAL_MENU_TEMPLATE_DETAILS_CLICK:
      return {
        ...state,
        contextualMenuSelectedTemplateDetails: payload,
        moreTemplateDetailsIsModal: true,
      };
      break;
    case ON_CLOSE_MORE_DETAILS_MODAL_CLICK:
      return {
        ...state,
        contextualMenuSelectedRowDetails: [],
        moreDetailsIsModal: payload,
      };
      break;
    case ON_CLOSE_TEMPLATE_MORE_DETAILS_MODAL_CLICK:
      return {
        ...state,
        contextualMenuSelectedTemplateDetails: [],
        moreTemplateDetailsIsModal: payload,
      };
      break;
    case ON_CONTEXTUAL_MENU_COPY_LINK_CLICK:
      return {
        ...state,
        copyLinkClick: true,
      };
      break;
    case ON_CONTEXTUAL_MENU_SHARE_LINK_CLICK:
      return {
        ...state,
        shareLinkClick: true,
      };
      break;
    case ON_CONTEXTUAL_MENU_SHARE_DOCUMENT_CLICK:
      return {
        ...state,
        shareDocumentClick: true,
      };
      break;
    case ON_UPLOAD_CLICK:
      return {
        ...state,
        uploadedLinks: payload,
      };
      break;
    case ON_REDIRECT_LINKS:
      return {
        ...state,
        uploadedLinks: payload,
      };
      break;
    case ON_PLATFORM_OPEN_LINK_CHANGE:
      return {
        ...state,
        linkPlatform: payload,
        uploadedLinks: [],
        copyLinkToggleValue: COPY_LINK_TOGGLE_VALUE_DEFAULT,
        copyLinkToggleValueDownload: COPY_LINK_TOGGLE_VALUE_DOWNLOAD,
        linkDownloadViewOption: false,
      };
      break;
    case ON_ACTIVE_PAGE_CHANGE:
      return {
        ...state,
        activePage: payload,
      };
      break;
    case ON_COPYLINK_TOGGLE_CHANGE:
      if (payload === true) {
        return {
          ...state,
          copyLinkToggleValue: "EDIT",
        };
      } else {
        return {
          ...state,
          copyLinkToggleValue: "VIEW",
        };
      }
      break;
    case ON_DOWNLOAD_VIEWTOGGLE_CHANGE:
      if (payload === true) {
        return {
          ...state,
          copyLinkToggleValueDownload: "DOWNLOAD",
        };
      } else {
        return {
          ...state,
          copyLinkToggleValueDownload: "VIEW",
        };
      }
      break;
    case ON_ONEDRIVE_SETTINGS_CHANGE:
      return {
        ...state,
        oneDriveLinkSettingOption: payload,
      };
      break;
    case ON_ONE_DRIVE_TOGGLE_ENABLE_DOWNLOAD_OR_NOT:
      return {
        ...state,
        oneDriveAllowDownload: payload,
      };
      break;
    case ON_ONE_DRIVE_ALLOW_EDITING_CHECKED:
      return {
        ...state,
        oneDriveAllowEditing: payload,
      };
      break;
    case POPUP_LINK_SETTING_MODAL:
      return {
        ...state,
        linkSettingsModalState: payload,
        selectedPeople: [],
        oneDriveLinkSettingOption: DEFAULT_ONE_DRIVE_LINK_SETTING_OPTION,
      };
      break;
    case POPUP_DOWNLOAD_VIEW_MODAL:
      return {
        ...state,
        downloadViewModalState: payload,
        // selectedPeople: [],
        linkDownloadViewOption: false,
      };
      break;
    case ON_POPUP_DOWNLOAD_VIEW_APPLY:
      return {
        ...state,
        downloadViewModalState: false,
        linkDownloadViewOption: true,
      };
      break;

    case ON_RECENT_OBJECT_VALUES:
      return {
        ...state,
        recentObjects: payload,
      };
      break;
    case ON_CHECKOUT_STATUS:
      return {
        ...state,
        checkoutStatusValue: payload,
      };
      break;
    case ON_ONEDRIVE_TOGGLE_OPEN_IN_REVIEW_MODE_ONLY:
      return {
        ...state,
        oneDriveReviewModeOnly: payload,
      };
      break;
    case ON_ADVANCE_SEARCH_DOC_CLASS_CHANGE:
      return {
        ...state,
        advanceSearchDocClass: payload,
      };
      break;
    case DOCCLASS_FORMAT_VALUES_FILTERED:
      return {
        ...state,
        docClassFormatValFiltered: payload,
      };
      break;
    case ON_ADVANCE_SEARCH_FORMAT_CHANGE:
      return {
        ...state,
        advanceSearchFormat: payload,
      };
      break;
    case ON_DIALOG_MENU_OK_BUTTON_CLICK:
      return {
        ...state,
        openDialogMenu: payload,
      };
      break;
    case ON_SUCCESS_DIALOG_MENU_OK_BUTTON_CLICK:
      return {
        ...state,
        openSucessDialog: payload,
      };
      break;
    case ON_MESSAGE_BOX_OK_BUTTON_CLICK:
      return {
        ...state,
        openMessageBox: payload,
      };
      break;
    case ON_WRONG_FILE_FORMAT:
      return {
        ...state,
        openDialogMenu: payload,
      };
      break;
    case ON_WRONG_FILE_FORMAT_TYPE:
      return {
        ...state,
        openDialogMenuType: payload,
      };
      break;
    case ON_MESSAGE_BOX_OPEN:
      return {
        ...state,
        openMessageBox: payload,
      };
      break;
    case ON_DISPLAY_DETAILS_BUTTON:
      return {
        ...state,
        displayDetailsButton: payload,
      };
      break;
    case ON_MESSAGE_BOX_INVOKE:
      return {
        ...state,
        messageBoxInfo: payload,
      };
      break;
    case ON_ONEDRIVE_OPTIONS_DATE_CHANGE:
      return {
        ...state,
        onedriveOptionsDate: payload,
      };
      break;
    case ON_ONEDRIVE_OPTIONS__PASSWORD_CHANGE:
      return {
        ...state,
        onedrivePassword: payload,
      };
      break;
    case ON_ONE_DRIVE_SETTING_APPLY_CLICK:
      return {
        ...state,
        uploadedLinks: payload,
        selectedPeople: [],
        urlGenerate: payload,
      };
      break;
    case ON_ONE_DRIVE_SETTING_CANCEL_CLICK:
      return {
        ...state,
        OnedriveCancelClick: payload,
      };
      break;
    case ON_ONEDRIVE_OPTIONS__PEOPLE_SELECTED:
      return {
        ...state,
        selectedPeople: payload,
      };
      break;
    case PEOPLE_PICKER_CONTACTS:
      return {
        ...state,
        contacts: payload,
      };

      break;
    case DOCCLASS_VALUES:
      return {
        ...state,
        docClassVal: payload,
      };
      break;
    case LOGICALUNIT_VALUES:
      return {
        ...state,
        logicalUnit: payload,
      };
      break;
    case DOCCLASS_FORMAT_VALUES:
      return {
        ...state,
        docClassFormatVal: payload,
      };
    case HIDE_SIDE_BAR:
      return {
        ...state,
        hideSideBar: payload,
      };
      break;
    case SMALL_SCREEN_SIZE:
      return {
        ...state,
        isSmallScreen: payload,
      };
      break;
    case ON_ONE_DRIVE_APPLY_BUTTON_DISABLE:
      return {
        ...state,
        isOneDriveApplyButtonDisable: payload,
      };
      break;
    case ON_DOC_CHECKIN_TYPE:
      return {
        ...state,
        docCheckinType: payload,
      };
      break;
    case LOADER_ACTIVE:
      return {
        ...state,
        loaderActive: payload,
      };
      break;
    case ON_SEARCH_DISABLE:
      return {
        ...state,
        isSearchDisable: payload,
      };
      break;
    case ON_EMPTY_RESULTS:
      return {
        ...state,
        emptyResultText: payload,
      };
      break;
    case ON_REVISIONSEARCH_CLICK:
      return {
        ...state,
        searchRevisionHide: payload,
      };
    case ON_ADV_OBJ_MODEL_HIDE:
      return {
        ...state,
        searchAdvanceObjectHide: payload,
      };
    case ON_ADV_OBJ_RECORD_SELECTED:
      return {
        ...state,
        searchAdvanceObjectSelected: payload,
      };
    case ON_REVISIONSEARCH_ITEM_SELECT:
      return {
        ...state,
        selectedRevisionItem: payload,
      };
    case ON_REVISION_SEARCH_LOAD:
      return {
        ...state,
        isSearchRevisionOn: payload,
      };
    case ON_ADV_OBJ_SELECT_COMPLETED:
      return {
        ...state,
        advObjCompleted: payload,
      };
    case ON_VIEWCOPY_UPLOAD_FAILED:
      return {
        ...state,
        viewCopyFail: payload,
      };
    case ON_NEWREVISION_DISABLED:
      return {
        ...state,
        newRevisionDisable: payload,
      };
    case ON_ADV_OBJ_RESULTS_STATUS_CHANGED:
      return {
        ...state,
        advObjResultsStatus: payload,
      };
    case ON_ADV_OBJ_META_DATA_STATUS_CHANGED:
      return {
        ...state,
        advSearchMedatDataStatus: payload,
      };
    case ON_DOCUMENT_UPLOAD_FAILED:
      return {
        ...state,
        documentUploadFailed: payload,
      };
    case FETCH_COPYRIGHT:
      return {
        ...state,
        copyRight: payload,
      };
    case TOGGLE_SIDEBAR:
      return {
        ...state,
        isToggleSideBar: payload,
      };
    case ON_CHECK_IN_TO_IFS_CLICKED:
      return {
        ...state,
        isCheckInToIFSClicked: payload,
      };
    case ON_CLEAR_ONEDRIVE_DOCUMENT_DOWNLOAD_URL:
      return {
        ...state,
        isOneDriveDownloadUrlCleared: payload,
      };
    case ON_CHECKIN_NEW_PAGE_NAME:
      return {
        ...state,
        checkinPageName: payload,
      };
    case ON_RESET_LANGUAGE:
      return {
        ...state,
        PageLoadLanguage: payload,
      };
    case CLICKED_ON_SAME_NAV_ITEM:
      return {
        ...state,
        isClickedOnSameNavItem: payload,
      };
    case ON_ONEDRIVE_DATALOAD:
      return {
        ...state,
        oneDriveDataLoad: payload,
      };
    case ON_MAIN_COMP_WIDTH_CHANGE:
      return {
        ...state,
        isMainCompWidthChange: payload,
      };
    case ON_OBJECTCONNECTION_DATALOAD:
      return {
        ...state,
        objectConnectionDataLoad: payload,
      };
    case ON_PAGINATION_LOAD:
      return {
        ...state,
        paginationLoad: payload,
      };
    case ON_FILTER_VISIBILITY:
      return {
        ...state,
        isFilterVisible: payload,
      };
    case ON_ONEDRIVE_FILTER_VISIBILITY:
      return {
        ...state,
        isOneDriveFilterVisible: payload,
      };
    case ON_NEWREVISION_INFO_CHANGED:
      return {
        ...state,
        newRevisionInfoChange: payload,
      };
    case ON_NEWREVISION_DOC_INFO_CHANGED:
      return {
        ...state,
        newRevisionDocInfo: payload,
      };

    case ON_TOKEN_FAIL:
      let defaultMessages = AZURE_USER_ACCESS_DENIED;
      let defaultErrorMessages = AZURE_USER_AUTHENTICATION_FAILURE;

      let messageBox = {
        type: ERROR_TYPE,
        message: defaultMessages,
        errorMessage: defaultErrorMessages,
        error: defaultErrorMessages,
      };

      if (!payload) {
        return {
          ...state,
          messageBoxInfo: messageBox,
          userDataLoadStatus: USER_DATA_LOAD_STATUS.onAzureUnauthorizedUser,
          azureUserStatus: USER_TOKEN_STATUS.unauthorized,
        };
      }

      messageBox.errorMessage = `Error Code: ${payload.responseCode}: ${
        payload.errorMessage ? payload.errorMessage : defaultErrorMessages
      }`;

      switch (payload.responseCode) {
        case 200:
          if (payload.refreshToken === true) {
            return {
              ...state,
              azureUserStatus: USER_TOKEN_STATUS.authorized,
            };
          } else {
            return {
              ...state,
              userDataLoadStatus: USER_DATA_LOAD_STATUS.onIFSUserValidation,
              azureUserStatus: USER_TOKEN_STATUS.authorized,
            };
          }
        case 204:
          messageBox.message = `${NO_USER_ACCOUNT}`;
          return {
            ...state,
            messageBoxInfo: messageBox,
            userDataLoadStatus: USER_DATA_LOAD_STATUS.onAzureUnauthorizedUser,
            azureUserStatus: USER_TOKEN_STATUS.unauthorized,
          };

        case 401:
          messageBox.message = `${AZURE_USER_ACCESS_DENIED}`;
          return {
            ...state,
            messageBoxInfo: messageBox,
            userDataLoadStatus: USER_DATA_LOAD_STATUS.onAzureUnauthorizedUser,
            azureUserStatus: USER_TOKEN_STATUS.unauthorized,
          };

        case 403:
          messageBox.message = `${FORBIDDEN}`;
          return {
            ...state,
            messageBoxInfo: messageBox,
            userDataLoadStatus: USER_DATA_LOAD_STATUS.onAzureUnauthorizedUser,
            azureUserStatus: USER_TOKEN_STATUS.expired,
          };

        case 400:
          messageBox.message = `${BAD_REQUEST_ERROR}`;
          return {
            ...state,
            messageBoxInfo: messageBox,
            userDataLoadStatus: USER_DATA_LOAD_STATUS.onAzureUnauthorizedUser,
            azureUserStatus: USER_TOKEN_STATUS.unauthorized,
          };

        case 404:
          messageBox.message = `${NO_USER_ACCOUNT}`;
          return {
            ...state,
            messageBoxInfo: messageBox,
            userDataLoadStatus: USER_DATA_LOAD_STATUS.onAzureUnauthorizedUser,
            azureUserStatus: USER_TOKEN_STATUS.expired,
          };

        default:
          messageBox.message = `${SERVER_RESPONSE_ISSUE}`;
          return {
            ...state,
            messageBoxInfo: messageBox,
            userDataLoadStatus: USER_DATA_LOAD_STATUS.onAzureUnauthorizedUser,
            azureUserStatus: USER_TOKEN_STATUS.unauthorized,
          };
      }

    case ON_ACCESS_TOKEN_STATUS:
      return {
        ...state,
        accessTokenStatus: payload,
      };
    case ON_DOCUMENT_STORAGE_MODE:
      return {
        ...state,
        documentStorageMode: payload,
      };
    case ON_ACCORDION_EXPANDED_CHANGE:
      return {
        ...state,
        accordionExpandedPanel: payload,
      };
    case ON_SUCCESS_MESSAGE_INVOKE:
      let defaultSuccessMessage = {
        type: SUCCESS_TYPE,
        title: DEFAULT_SUCCESS_TITLE,
        message: DEFAULT_SUCCESS_MESSAGE,
      };
      let successMessage = getPayloadValue(payload, defaultSuccessMessage);
      successMessage.title = getPayloadValue(payload.title, defaultSuccessMessage.title);
      successMessage.message = getPayloadValue(payload.message, defaultSuccessMessage.message);
      return {
        ...state,
        successMessageInfo: successMessage,
        showSuccessMessage: true,
      };
    case ON_SUCCESS_MESSAGE_CLOSE:
      return {
        ...state,
        successMessageInfo: [],
        showSuccessMessage: false,
      };
    case ON_WARNING_MESSAGE_INVOKE:
      let defaultWarningMessage = {
        type: WARNING_TYPE,
        message: VALIDATION_FAILED_ERROR,
        errorMessage: "",
        error: null,
      };
      let warningMessage = getPayloadValue(payload, defaultWarningMessage);
      return {
        ...state,
        messageBoxInfo: warningMessage,
        openMessageBox: true,
      };
    case ON_ERROR_MESSAGE_INVOKE:
      let defaultMessage = {
        type: ERROR_TYPE,
        message: VALIDATION_FAILED_ERROR,
        errorMessage: "",
        error: null,
      };
      let message = getPayloadValue(payload, defaultMessage);
      return {
        ...state,
        messageBoxInfo: message,
        openMessageBox: true,
      };
    case ON_SERVER_ERROR_MESSAGE_INVOKE:
      let errorMessageBox = {
        type: ERROR_TYPE,
        message: IFS_SERVER_ERROR,
        errorMessage: "",
        error: null,
        showMessageBox: true,
      };
      let response = isValidPlayload(payload)
        ? getPayloadValue(payload.response, null)
        : null;

      const statusCode = payload?.statusCode ?? (response ? response.status : null);

      if (statusCode === 400) {
        let msg400 = "";
        if (response && response.data) {
          const d = response.data;
          if (typeof d === "string" && d.trim()) {
            msg400 = d;
          } else if (typeof d === "object" && d !== null) {
            msg400 = d.Exception || 
                     (d.Messages && Array.isArray(d.Messages) ? d.Messages.join(", ") : "") ||
                     d.message || 
                     d.detail || 
                     d.title || 
                     d.error || 
                     d.Error || 
                     "";
          }
        }
        if (!msg400 && payload?.error?.message) {
          msg400 = payload.error.message;
        }
        errorMessageBox.message = msg400 || BAD_REQUEST_ERROR;
      } else {
        if (response !== null) {
          if (response.data) {
            const d = response.data;
            if (typeof d === "string") {
              errorMessageBox.message = d;
            } else if (typeof d === "object" && d !== null) {
              if (typeof d.detail === "string" && d.detail.trim()) {
                errorMessageBox.message = d.detail;
              } else if (typeof d.title === "string" && d.title.trim()) {
                errorMessageBox.message = d.title;
              } else {
                errorMessageBox.message = IFS_SERVER_ERROR;
              }
            } else {
              errorMessageBox.message = `${d}`;
            }
          } else {
            const errMsg =
              payload.error && typeof payload.error.message === "string"
                ? payload.error.message
                : null;
            errorMessageBox.message =
              errMsg !== null
                ? `${ERROR_DETAILS} ${errMsg}`
                : `${ERROR_DETAILS} ${IFS_SERVER_ERROR}`;
          }
        } else {
          let errorMessage = getPayloadValue(payload.error.message, null);
          errorMessageBox.message =
            errorMessage !== null
              ? `${ERROR_DETAILS} ${errorMessage}`
              : IFS_SERVER_ERROR;
        }
      }

      errorMessageBox.showMessageBox = getPayloadValue(
        payload.showMessageBox,
        true,
      );
      return {
        ...state,
        messageBoxInfo: errorMessageBox,
        openMessageBox: getPayloadValue(errorMessageBox.showMessageBox, true),
      };
    case ON_EXCEPTION_MESSAGE_INVOKE:
      let defaultErrorMessage = {
        message: EXCEPTION_ERROR,
        showMessageBox: true,
      };
      let exceptionMessage = getPayloadValue(payload, defaultErrorMessage);
      let exceptionErrorBox = {
        type: ERROR_TYPE,
        message: exceptionMessage.message,
        errorMessage: "",
        error: null,
      };
      return {
        ...state,
        messageBoxInfo: exceptionErrorBox,
        openMessageBox: getPayloadValue(exceptionMessage.showMessageBox, true),
      };
    case ON_LOGIN_REFRESH_PREACTION_INVOKE:
      return {
        ...state,
        tokenRefreshPreActionInvoke: getPayloadValue(payload, {
          retry: 0,
          actionType: REFRESH_TOKEN_ACTION.none,
        }),
      };
    default:
      return state;
  }
}

export default metadataReducer;
